import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getLength, getSpacing, createStyleFunction } from 'utils/ui';
export var alignMap = {
  top: 'flex-start',
  left: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
  right: 'flex-end',
  stretch: 'stretch',
  baseline: 'baseline'
};
var distributedAlignMap = _objectSpread(_objectSpread({}, alignMap), {}, {
  'space-between': 'space-between',
  'space-around': 'space-around',
  'space-evenly': 'space-evenly'
});

// TODO: extend with CSSProperties["alignContent"]

export var flexPropsDef = [{
  styleProp: 'flexWrap',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'wrapItems',
  properties: ['flexWrap'],
  getValue: function getValue(value) {
    return value ? 'wrap' : 'nowrap';
  }
}, {
  styleProp: 'basis',
  properties: ['flexBasis'],
  getValue: getLength
}, {
  styleProp: 'grow',
  properties: ['flexGrow'],
  getValue: function getValue(value) {
    return Number(value);
  }
}, {
  styleProp: 'shrink',
  properties: ['flexShrink'],
  getValue: function getValue(value) {
    return Number(value);
  }
}, {
  styleProp: 'flexAlign',
  properties: ['alignSelf'],
  getValue: function getValue(value) {
    return alignMap[value] || value;
  }
}, {
  styleProp: 'alignItems',
  getValue: function getValue(value) {
    return alignMap[value] || value;
  }
}, {
  styleProp: 'justifyContent',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'justifySelf',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'flexDirection',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'stackItems',
  properties: ['flexDirection'],
  getValue: function getValue(value) {
    return value ? 'column' : 'initial';
  }
}, {
  styleProp: 'gridArea',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'gridColumn',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'gridRow',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'gap',
  getValue: getSpacing
}, {
  styleProp: 'rowGap',
  getValue: getSpacing
}, {
  styleProp: 'columnGap',
  getValue: getSpacing
}];
export var baseFlexRules = {
  /* Reset flex */
  flex: 'none',
  /* Prevent overflowing content from expanding flex items */
  minWidth: 0
};
var flexProps = createStyleFunction(flexPropsDef, baseFlexRules);
export default flexProps;